module.exports = __webpack_public_path__ + "img/details.bab1d391.svg";